<template>
    <div>
      <MdTitle v-bind:Text="$t('Nurses.PatientMarsReport')" />

      <div class="flex-container">

        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
          <div class="input-group" dir="ltr">
            <input type="text" :dir="dirInput" class="form-control" v-model="parameter.SearchCriteria"
              @keyup.enter="onClickViewData">

            <div class="input-group-append">
              <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                v-bind:IconClass="'mdi mdi-magnify'" v-on:click="onClickViewData">
              </MdButton>
            </div>
          </div>
        </div>

        <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.month')"
              v-bind:Options="MonthList"
              v-bind:ModelArray="month"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:Multiple="false"
              v-bind:RequireEvent="true"
              v-bind:IfUsevalidation="false"
              :Input="ChangeDropDownMonths"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.year')"
              v-bind:Options="YearList"
              v-bind:ModelArray="year"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:Multiple="false"
              v-bind:RequireEvent="true"
              v-bind:IfUsevalidation="false"
              :Input="ChangeDropDownYear"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Program',2)"
              v-bind:Options="ProgramList"
              v-bind:Model="ProgramVmodel"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Placeholder="selectPlaceholder"
              v-bind:Multiple="true"
              v-bind:RequireEvent="true"
              v-bind:IfUsevalidation="false"
              :Input="ChangeDropDownPrograms"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientList"
              v-bind:Model="Patients"
              v-bind:FieldDescription="'patientname'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="true"                       
              :Input="ChangeDropDownPatients"/> 
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Building')"
              v-bind:Options="BuildinsList"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="buildings"   
              v-bind:Multiple="buildingsEnabled ? true : false"
              :Input="ChangeDropDownBuilding"
              v-bind:IsDisabled="!buildingsEnabled"
            />
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Level')"
              v-bind:Options="LevelList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Model="level"                       
              v-bind:Multiple="true"
              :Input="ChangeDropDownLevel"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Room')"
              v-bind:Options="RoomList"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'" 
              v-bind:UseResetModel="true"                 
              v-bind:Model="room"                       
              v-bind:Multiple="true"
              :Input="ChangeDropDownRoom"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
              <MdSelect
              v-bind:Label="$t('modalMarsMed.Mode')"
              v-bind:Options="ModeList"
              v-bind:Model="mode"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:Placeholder="selectPlaceholder"
              v-bind:Multiple="true" 
              :Input="ChangeDropDownMode"/>
              
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col md="12">
          <div class="text-center text-md-right mt-3">
            <button 
              v-on:click="onClickViewData"
              type="button"
              class="btn btn-primary btn-login mx-2 pull-right"												
              id="btnsearchinput">
              {{ $t('Shared.Search') }}
            </button>
          </div>
        </b-col>
      </b-row>

      <br>

      <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        
      <div v-if="showEmptyRecords" v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite">
          <div class="text-center my-2">{{$t('MdTable.nRecShow')}}</div>
      </div>

       <MdMarsViewBox v-bind:Items="this.items"/>

       <div class="row mt-4" dir="ltr">
        <div class="my-1 col-sm-7 col-md-6">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            @change="onChange"
            pills
            size="lg"
          ></b-pagination>
        </div>
        <div align="right" class="mr-2 col">
          {{ $t('Shared.Show') }}
          <b-form-select 
            v-model="perPage" 
            :options="options" 
            size="sm" 
            id="perPageSelect"
            v-bind:style="perPageStyle"
            @change="perPageChange">
          </b-form-select>
          {{ $t('Shared.Of') }} {{totalRows}}
        </div>
      </div>


       <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
         <!-- <MdButton
            v-bind:Label="$t('Mars.ViewData')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickViewData"
            v-bind:Name="'btn_Print'"/>  --> 
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>   
        </div>
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="reportTitle"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="Mars"
          :ReportName="'NursesMars'"
          :ReportTitle="reportTitle"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import Utils from '../../../common/utils'
    import DBFunctions from '@/common/DBFunctions.js'
    import ClinicalService from '@/services/clinical.service'
    import PatientService from '@/services/patient.service'
    import AdmissionService from '@/services/admission.service'
    import GlobalService from '@/services/global.service'
    import MarsService from '@/services/mars.service' 
    import EnumService from "@/services/enum.service";
    import Permission from '@/common/Permission'
    import { EventBus } from '@/event-bus.js';

    export default Vue.extend({
        name: "PatientMarsRep",
        mixins: [ ShowMessage, Utils, DBFunctions, Permission ],
        components: { DxPopup },
        data() {
            return {
              showEmptyRecords: false,
                isReportVisible: false,
                reportParams: [],
                showFilters: true,
                ProgramVmodel: [],
                ProgramList: [],
                Patients: "",
                PatientList: [],
                buildings:"",
                BuildinsList:[],
                level:"",
                LevelList:[],
                room:"",
                RoomList:[],
                month:{},
                MonthList: EnumService.Months,
                year: {'name':new Date().getFullYear(),'value': new Date().getFullYear()},
                YearList: [],
                mode:[],
                ModeList: EnumService.MarsMode,
                perPageStyle: {
                width: 'auto'
                },
                parameter:{  
                  Month: null,
                  Year: null,
                  PatientList:[],
                  LevelList:[],
                  BuildingList:[],
                  RoomList:[],
                  ProgramList:[],
                  ModeList:[],
                  SearchCriteria:'',
                  PageSize:5,
                  PageNumber:1
                },
                selectPlaceholder: this.$t('Clinical.SelectOptions'),
                reportTitle: this.$t('Nurses.PatientMars'),

                emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
              },

                fullParam: {
                  PageSize:0,
                  PageNumber:0
                },
                items: [],
                currentPage: 1,
            perPage: 10,
            totalRows: 0, 
            Header:{},
            options: [
                { value: 5, text: '5' },
                { value: 10, text: '10' },
                { value: 15, text: '15' },
                { value: 50, text: '50' },
            ],
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
          }
        },

        computed: {
          buildingsEnabled() {
            return Utils.isNullOrEmptyString(this.$store.state.restrictions.buildingLocation);
          }
        },

        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
            },

            reportList() {
              this.checkExistFavorite('/app/reports/patients');
              this.$router.push({ name: "reportListPatient" }).catch(()=>{});
            },

            onClickShowReport() {
              this.reportParams = []

              let buildingList = this.parameter.BuildingList;
              if (!this.buildingsEnabled) {
                  buildingList = [this.$store.state.restrictions.buildingLocation];
              }

              let programList = this.parameter.ProgramList;
              if (this.parameter.ProgramList.length === 0) {
                  programList = [...this.$store.state.restrictions.programs];
              }

              this.reportParams.push({ paramName: 'Month', paramValue: this.month.value})
              this.reportParams.push({ paramName: 'Year', paramValue: this.year.value})
              this.reportParams.push({ paramName: 'ProgramCodeList', paramValue: programList})
              this.reportParams.push({ paramName: 'PatientCodeList', paramValue: this.parameter.PatientList})
              this.reportParams.push({ paramName: 'BuildingCodeList', paramValue: buildingList})
              this.reportParams.push({ paramName: 'LevelCodeList', paramValue: this.parameter.LevelList})
              this.reportParams.push({ paramName: 'RoomCodeList', paramValue: this.parameter.RoomList})
              this.reportParams.push({ paramName: 'ModeList', paramValue: this.parameter.ModeList})
              this.reportParams.push({ paramName: 'SearchCriteria', paramValue: this.parameter.SearchCriteria})

              this.isReportVisible = true
              this.$refs.Mars.buildDocument(this.reportParams)
            },

          ChangeDropDownPrograms(items){           
              this.parameter.ProgramList = []; 
              let arr = [];
              if(items.length > 0){
                items.forEach(function(element) {
                  arr.push(element.code) 
                })
                this.parameter.ProgramList = arr; 
              }
              this.currentPage = 1;
              this.perPage = 5;
              this.onClickViewData();
          },

          ChangeDropDownPatients(items){
              this.parameter.PatientList = [];
              let arr = [];
              if(items.length > 0){
                items.forEach(function(element) {
                  arr.push(element.patientcode) 
                })
                this.parameter.PatientList = arr; 
              }
              this.currentPage = 1;
              this.perPage = 5;
              this.onClickViewData();
          },

          async ChangeDropDownBuilding(items){
              this.parameter.BuildingList = [];
              let arr = [];
              if(items.length > 0){
                items.forEach(function(element) {
                  arr.push(element.code) 
                })
                this.parameter.BuildingList = arr; 
              }
 
              await this.getRomms({BuildingCodeList:this.parameter.BuildingList});
              this.parameter.RoomList = [];
              this.room ? this.parameter.RoomList.push(this.room) : this.parameter.RoomList;
              this.currentPage = 1;
              this.perPage = 5;
              this.onClickViewData();
          }, 

          async ChangeDropDownLevel(items){
              this.parameter.LevelList = [];             
             let arr = [];
              if(items.length > 0){
                items.forEach(function(element) {
                  arr.push(element.code) 
                })
                this.parameter.LevelList = arr; 
              }
              this.currentPage = 1;
              this.perPage = 5;
              this.onClickViewData();
          },

          ChangeDropDownRoom(items){
              this.parameter.RoomList = [];            
              let arr = [];
              if(items.length > 0){
                items.forEach(function(element) {
                  arr.push(element.code) 
                })
                this.parameter.RoomList = arr; 
              }

              this.currentPage = 1;
              this.perPage = 5;

              this.onClickViewData();
          },

          ChangeDropDownMonths(item) {
              const aCurrMonth = new Date().getMonth() + 1;
              this.parameter.Month = item ? item.value : aCurrMonth; 
              this.currentPage = 1;
              this.perPage = 5;
              this.onClickViewData();            
          },

          ChangeDropDownYear(item) {
              const currentYear = new Date().getFullYear();
              this.parameter.Year = item ? item.value : currentYear;

              this.currentPage = 1;
              this.perPage = 5;

              this.onClickViewData();
          },

          ChangeDropDownMode(items) {            
              this.parameter.ModeList = []; 
              let arr = [];
              if(items.length > 0){
                items.forEach(function(element) {
                  arr.push(element.value) 
                })
                this.parameter.ModeList = arr; 
              }

              this.currentPage = 1;
              this.perPage = 5;

              this.onClickViewData();
          },

          async getRomms(build){       
            await MarsService.getMarsRooms(build)
              .then((response) => {
                if(response.status == '200' && response.data.length > 0){                         
                  this.RoomList = response.data;
                  if(this.RoomList.length === 1){
                    this.room = this.RoomList[0].code;
                  }
                }                             
              })
              .catch((error) => {
                /*if (error.response) {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
                this.showResponseErrorMessage(error);
              }); 
          },

          async getLevel(){
            let param = { CodeType:"RoomLevel" };
            await GlobalService.getGlobalCustom(param)
              .then((response) => {
                if(response.status == '200' && response.data.length > 0){                          
                  this.LevelList = response.data;
                }                             
              })
              .catch((error) => {
                /*if (error.response) {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
                this.showResponseErrorMessage(error);
              }); 
          },

          async getPrograms(){
            const parameter = {
                programsRestriction:  this.$store.state.restrictions.programs
            }
            await ClinicalService.getPrograms(parameter)
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){                        
                  this.ProgramList = response.data;                                          
                }               
              })
              .catch((error) => {
                /*if (error.response) {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
                this.showResponseErrorMessage(error);
              });  
          },

          async getPatients(){   
            await PatientService.getAll(this.fullParam)
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0) {               
                  this.PatientList = response.data;                          
                    this.PatientList.forEach(function(element) {	
                      element.patientname = element.firstname + " " + element.lastname + " - "+element.patientcode;   
                      });       
                  }       
              })
              .catch(error => {      
                /*if (!error.response) {
                  // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
                this.showResponseErrorMessage(error);
              });    
          },

          async getBuildings(){
            await AdmissionService.getBuildings({Code: this.$store.state.restrictions.buildingLocation})
              .then((response) => {
                if(response.status == '200'){                       
                  this.BuildinsList = response.data;     
                  
                  if (!this.buildingsEnabled) {
                    this.buildings = this.$store.state.restrictions.buildingLocation;
                    this.parameter.BuildingList.push(this.buildings);
                  }
                }                             
              })
              .catch((error) => {
                /*if (error.response) {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
                this.showResponseErrorMessage(error);
              });
          },

          getYears() {
            const currentYear = new Date().getFullYear();
            const ayears = Array.from({ length: 100 }, (_, i) =>  currentYear - i);
            let years = []

            ayears.forEach(year => {
              years.push({'name': year, 'value': year})
            });

            this.parameter.Year = currentYear
            this.YearList = years; 
          },
          
          getCurrMonth() {
            const aCurrMonth = new Date().getMonth() + 1;
            const currmonth = this.MonthList.find(el => el.value == aCurrMonth)
            
            this.parameter.Month = aCurrMonth
            this.month = currmonth
          },

          setDefaultMode() {
            //const defaultMode = this.ModeList.find(el => el.value == 'all')
            
            this.parameter.Mode = [];
            this.mode = [];
           // this.parameter.Mode.push(defaultMode.value);
           // this.mode.push(defaultMode.value);
          },

          perPageChange(page){
            this.perPage = page;           
            this.onClickViewData();
          },
          onChange(page){
            this.currentPage = page;          
            this.onClickViewData();
          },

        formatDate(date) {
          return Utils.formatterDateToString(date)
        },

        formatTime(time) {
          return Utils.formatTime(time)
        },

          PopulateDateTimes(arr){
            for(var i = 0 ; i < arr.length; i++){
              for(var j = 0 ; j < arr[i].prnMedications.length; j++){
                for(var k = 0 ;  k < arr[i].prnMedications[j].administrations.length; k++){
                  let adate = arr[i].prnMedications[j].administrations[k].adminDate ? this.formatDate(arr[i].prnMedications[j].administrations[k].adminDate) : "";
                  let atime = arr[i].prnMedications[j].administrations[k].adminTime ? this.formatTime(arr[i].prnMedications[j].administrations[k].adminTime):"";
                  let gdate = arr[i].prnMedications[j].administrations[k].givenDate ? this.formatDate(arr[i].prnMedications[j].administrations[k].givenDate) :"";
                  let gtime = arr[i].prnMedications[j].administrations[k].givenTime ? this.formatTime(arr[i].prnMedications[j].administrations[k].givenTime) :"";

                  let aDateTime = adate && atime ? adate + " "+atime :""; 
                  let gDateTime = gdate && gtime ? gdate + " "+gtime :"";
                  arr[i].prnMedications[j].administrations[k].adminDateTime = aDateTime;
                  arr[i].prnMedications[j].administrations[k].givenDateTime = gDateTime
                }
              }
            }
          },

          onClickViewData() {           
            //this.parameter.Month = this.month;
            //this.parameter.Year = this.year.value;
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            const parameters = {
              ...this.parameter
            }
            if (this.parameter.ProgramList.length === 0) {
                parameters.ProgramList = [...this.$store.state.restrictions.programs];
            }

            this.$emit('load', true);           
            MarsService.repViewPatientMars(parameters)
              .then((response) => {
                if(response.status == '200' && response.data){
                  this.items = response.data;
                  this.PopulateDateTimes(this.items);
                  this.showEmptyRecords = response.data && response.data.length == 0 ? true : false;
                  let headerString = response.headers["x-pagination"];
                  this.Header = JSON.parse(headerString);
                  this.totalRows = this.Header.TotalCount;
                  this.$emit('load', false);  
                }  
                this.$emit('load', false);           
              })
              .catch((error) => {                   
                this.$emit('load', false);               
                  /*if (!error.response) {
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                  }                      
                  else if(error.response.status === 400 ){
                    this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                  }                    
                  else if(error.response.status === 500){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                  } else{
                    this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                  }*/
                this.showResponseErrorMessage(error); 
                            
              }); 
          },
      },

        
        created(){
          this.getYears();
          this.getCurrMonth();
          this.setDefaultMode();
          this.getPrograms();
          this.getPatients();
          this.getBuildings();
          this.getLevel();  
          this.parameter.Month = this.month.value;
          this.parameter.Year = this.year.value;  
        },
        
        mounted () {      
          this.StatusModel = {"value":"ACTIVE","name":"Active"};
          this.onClickViewData();
          EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
          }.bind(this));
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
